var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-input',{attrs:{"type":"switch"},on:{"input":_vm.changeEarning},model:{value:(_vm.switchValue),callback:function ($$v) {_vm.switchValue=$$v},expression:"switchValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }